import { Button } from '@library/components/buttons';
import { cn } from '@library/component-utils/cn';
import refreshIcon from '@library/assets/images/icons/refresh-icon.svg';

export interface ResetIconButtonProps {
  className?: string;
  disabled?: boolean;
  label?: string;
  onClick: () => void;
}

export const ResetIconButton = ({
  className = '',
  disabled = false,
  label = '',
  onClick
}: ResetIconButtonProps) => {
  return (
    <Button
      className={cn(
        'text-soClean-100 flex-center ml-4 flex items-center bg-transparent text-[13px] font-medium',
        className
      )}
      disabled={disabled}
      data-testid="ResetIconButton"
      onClick={onClick}
      type="button"
    >
      <img className="mr-2 w-3.5" src={refreshIcon} alt={label} />
      <span className="leading-relaxed">{label}</span>
    </Button>
  );
};
